import gql from 'graphql-tag';
import { slateGQLFields } from './slate.fields.js';
export const updateSlatesGQLMutation = (fields) => gql `
  mutation UpdateSlates($input: [UpdateSlateInput!]!) {
    updateSlates(input: $input) {
      ${slateGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=slate.gql.js.map